import React from "react";
import cameraIcon from "@/assets/icons/camera.svg";
import emailIcon from "@/assets/icons/email.svg";
import styles from "./helpItemDamagedOnDelivery.module.scss";

function HelpItemDamagedOnDelivery() {
  return (
    <div className={styles.container}>
      <section>
        <h3>
          We apologise that your item has arrived damaged.
          <br />
          In order to resolve this issue please follow these steps
        </h3>

        <div className={styles.stepsContainer}>
          <div className={styles.stepContainer}>
            <div className={styles.iconAndSeperator}>
              <div className={styles.stepIcon}>
                <img src={cameraIcon.src} alt="camera" />
              </div>
              <div className={styles.stepSeparator} />
            </div>
            <span>Take photos of the damaged item.</span>
          </div>

          <div className={styles.stepContainer}>
            <div className={styles.iconAndSeperator}>
              <div className={styles.stepIcon}>
                <img src={emailIcon.src} alt="email" />
              </div>
            </div>
            <span>Send them to us via live chat or email and provide details about the damage.</span>
          </div>
        </div>
      </section>
    </div>
  );
}

export default HelpItemDamagedOnDelivery;
